module.exports = __webpack_public_path__ + "img/75.a1ceede6.svg";